import { Component, HostBinding, Input, ViewEncapsulation, } from '@angular/core';
import { BaseDirective } from '../../base.directive';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'eui-feedback-message',
    styleUrls: ['./styles/_index.scss'],
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None
})
export class EuiFeedbackMessageComponent extends BaseDirective {

    @HostBinding('class')
    public get cssClasses(): any {
        return [
            super.getCssClasses('eui-feedback-message'),
            this.styleClass ? this.styleClass : ''
        ].join(' ').trim();
    }

    @Input() styleClass: string;
    @HostBinding('attr.type') protected type: string = 'MessageFeedback';

    constructor() {
        super();
    }

}
